import React from 'react';

export default function StatCard({ icon: Icon, label, value, color = 'primary', onClick, trend }) {
  const colorMap = {
    primary: 'bg-primary-100 text-primary-600',
    green: 'bg-green-100 text-green-600',
    gold: 'bg-yellow-100 text-yellow-600',
    red: 'bg-red-100 text-red-600',
    navy: 'bg-navy-200 text-navy-600',
    purple: 'bg-purple-100 text-purple-600',
  };

  return (
    <div
      className={`card ${onClick ? 'cursor-pointer hover:shadow-apple-md' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-center">
        <div className={`h-12 w-12 rounded-apple flex items-center justify-center ${colorMap[color] || colorMap.primary}`}>
          <Icon className="h-6 w-6" />
        </div>
        <div className="ml-4 flex-1">
          <p className="text-sm text-navy-500">{label}</p>
          <div className="flex items-baseline gap-2">
            <p className="text-2xl font-bold text-navy-900">{value}</p>
            {trend !== undefined && trend !== null && (
              <span className={`text-xs font-medium ${trend >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                {trend >= 0 ? '+' : ''}{trend}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
